// src/App.js
import React, { useEffect, useState } from 'react';
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate
} from 'react-router-dom';
import { onAuthStateChanged } from 'firebase/auth';
import { auth, db }           from './firebase';
import { doc, getDoc }        from 'firebase/firestore';
import './index.css';


import Login            from './pages/Login';
import AdminDashboard   from './pages/AdminDashboard';
import TeacherDashboard from './pages/TeacherDashboard';

function App() {
  const [user, setUser]       = useState(null);
  const [role, setRole]       = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Listen for auth state
    const unsubscribe = onAuthStateChanged(auth, async (u) => {
      if (u) {
        setUser(u);
        // Fetch this user’s role from Firestore
        const snap = await getDoc(doc(db, 'users', u.uid));
        setRole(snap.exists() ? snap.data().role : null);
      } else {
        setUser(null);
        setRole(null);
      }
      setLoading(false);
    });
    return unsubscribe;
  }, []);

  if (loading) return <div>Loading…</div>;

  return (
    <Router>
      <Routes>
        <Route
          path="/login"
          element={user ? <Navigate to="/" /> : <Login />}
        />
        <Route
          path="/"
          element={
            !user ? (
              <Navigate to="/login" />
            ) : role === 'admin' ? (
              <AdminDashboard />
            ) : (
              <TeacherDashboard />
            )
          }
        />
        {/* Fallback: redirect anything else to / */}
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </Router>
  );
}

export default App;
